// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment} from 'react';
import {useHistory} from 'react-router-dom';
import cn from 'classnames';
import {toolip_img_url} from '../../../../hola/pub/ui/toolip_img_url';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import styles from './nav_menu.module.less';
import {use_menu_config} from './nav_utils';

interface i_product_card_props {
    product: string;
    to: string;
    title: string;
    sub_title: string;
    icon: string;
}
export const Product_card = (props: i_product_card_props)=>{
    const {product, to, title, sub_title, icon} = props;
    const {T} = use_translation_v({no_defaults: true});
    const history = useHistory();
    const card_cls = cn(styles.product_card, styles[product]);
    return <div className={card_cls}
      onClick={()=>history.push(to)}>
      <div className={styles.img}><img src={toolip_img_url(icon)}/></div>
      <div className={styles.content}>
        <a href={to}
          className={styles.title}><T>{title}</T></a>
        <p className={styles.text}><T>{sub_title}</T></p>
      </div>
    </div>;
};

export const Product_menu = ()=>{
    const {T} = use_translation_v({no_defaults: true});
    const menu = use_menu_config();
    return <div className={styles.products_menu}>
      {menu.products.group_items.map((group, idx, all)=>
        <Fragment key={group.title}>
          <div className={styles.group}>
            <p className={styles.group_title}><T>{group.title}</T></p>
            <div className={styles.items}>
              {group.items.map(item=>
                <Product_card key={item.id}
                  product={item.id}
                  title={item.title} sub_title={item.sub_title}
                  to={item.to} icon={item.icon} />
              )}
            </div>
          </div>
          {idx < all.length-1 && <div className={styles.group_separator}/>}
        </Fragment>
      )}
    </div>;
};
